import { Button } from "antd";
import { handleStagesButtonText } from "containers/cardOnboarding/services/data.transformers";
import { useTranslation } from "react-i18next";
import Rules from "components/rules";

const OnbButton = ({
  data,
  onChangeRules,
  handleRulesClick,
  disabled,
  loading = true,
  failed,
  current,
  onClick,
}) => {
  const { t } = useTranslation();

  const renderRules = () => {
    return (
      current === 0 && (
        <Rules
          onChangeRules={onChangeRules}
          handleRulesClick={handleRulesClick}
        />
      )
    );
  };
  const handleClassBtn = () => {
    const state = !["finalize", "message"].includes(
      `${data?.current_stage}`.toLowerCase()
    );
    if (current === 0 && !failed && disabled) return "disabled-button-large";
    if (state) return "primary-button-large";
  };

  return (
    <div className="p-5 fixed bottom-0  border-t bg-white sm:bg-transparent border-gray--7 max-w-2xl  w-full  sm:border-none">
      {!failed && !loading && renderRules()}
      <Button
        loading={loading}
        disabled={current === 0 && !failed ? disabled : false}
        className={`default-button-large ${handleClassBtn()} min-h-[46px] justify-center items-center`}
        block
        onClick={onClick}
      >
        {!loading && handleStagesButtonText(data, current, failed, t)}
      </Button>
    </div>
  );
};
export default OnbButton;
